export const enumPermisosAlmaseg = Object.freeze({
  ALMASEG_RETIROS: 100,
});
